<template>
  <div v-if="query.length > 0 && getProductsCount > 0 || getProductsCount === 0 && query || !allowEmptyQuery && !query"
       class="smartsearch-serp__result-info-container q-container-xxl q-pt-1 q-d-flex">
    <div class="q-lead q-container-fluid q-pb-1 q-my-1">
      <h1 v-if="query.length > 0 && getProductsCount > 0"
          class="results__info-header q-fw-normal q-text-dark q-mb-0 q-text-left q-fs-5">
        {{ SmartSearchTranslations.serp.resultHeader }}:<br class="q-d-block q-d-lg-none"> <b>{{ query }}</b> ({{ total }}
        {{ SmartSearchTranslations.serp.results }})
      </h1>
      <p v-if="typeQueryState" class=" q-fw-normal q-text-dark q-mb-0 q-text-center q-small">
        {{ SmartSearchTranslations.serp.typeQuery }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import {storeToRefs} from "pinia";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {computed, inject} from "vue";
import {SmartSearchConfigInterface, SmartSearchTranslationsInterface} from "@/core/types";


// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchConfig = inject<SmartSearchConfigInterface>('SmartSearchConfig')!
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!
const {allowEmptyQuery} = SmartSearchConfig.value.serp.query


const serpStore = useSerpResultsStore();

const {query, total, getProductsCount, loading} = storeToRefs(serpStore)
const typeQueryState = computed(() => {
  return !loading.value && !allowEmptyQuery && !query.value
})


</script>
<style scoped>
@media (max-width: 991.98px) {
  .results__info-header {
    font-size: 1em !important;
    text-align: center;
  }
}

</style>
